import { i18n } from '@/locale';
import { validChar } from '@/utils/validator';

export function validUserName(_, value, callback) {
  if (!value || value.trim() === '') {
    callback(new Error(i18n.t('请输入用户名')));
  } else if (validChar(value, 'MULTI_SPACE')) {
    callback(new Error(i18n.t('不支持连续空格')));
  } else {
    callback();
  }
}

export function validPassword(_, value, callback) {
  if (!value || value.trim() === '') {
    callback(new Error(i18n.t('请输入密码')));
  }

  callback();
}
